import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBagFillingMachine = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 100,
	viewBox: "0 0 80.0 100.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 80,
			height: 100,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10,
			y: 20,
			width: 25,
			height: 35,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 45,
			y: 20,
			width: 25,
			height: 35,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 75.0 80.0 L 20.0 80.0 M 22.5 19.5 L 15.0 10.0 L 30.0 10.0 Z M 22.5 10.0 L 22.5 20.0 M 57.5 19.5 L 50.0 10.0 L 65.0 10.0 Z M 57.5 10.0 L 57.5 20.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 20.0 77.0 L 20.0 83.0 L 9.0 80.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgBagFillingMachine;
